function toText(value, fallback = '') {
  if (typeof value === 'string') {
    return value;
  }

  if (value == null) {
    return fallback;
  }

  return String(value);
}

export function normalizePost(post) {
  if (!post || typeof post !== 'object') {
    return null;
  }

  const rawId = post.id ?? post.ID ?? post.slug ?? post.Slug ?? null;

  return {
    ...post,
    id: rawId == null ? null : String(rawId),
    title: toText(post.title ?? post.Title, 'Untitled Post'),
    excerpt: toText(post.excerpt ?? post.Excerpt),
    content: toText(post.content ?? post.Content),
    createdAt: post.created_at ?? post.createdAt ?? post.CreatedAt ?? null,
  };
}

export function normalizePosts(posts = []) {
  return posts.map(normalizePost).filter(Boolean);
}

export function normalizeRoutePostId(routeId = '') {
  return String(routeId).replace(/^post-/, '');
}

export function matchesPostRoute(post, routeId) {
  const requestedId = String(routeId);
  const normalizedId = normalizeRoutePostId(routeId);
  const candidates = [];

  if (post?.id) {
    candidates.push(String(post.id), `post-${post.id}`);
  }

  if (post?.slug) {
    candidates.push(String(post.slug));
  }

  return (
    candidates.includes(requestedId) ||
    candidates.includes(normalizedId) ||
    candidates.includes(`post-${normalizedId}`)
  );
}

export function findPostByRouteId(posts, routeId) {
  return posts.find((post) => matchesPostRoute(post, routeId)) ?? null;
}

export function buildPostPath(post) {
  return post?.id ? `/blog/${post.id}` : '/blog';
}

export function formatPostDate(value) {
  if (!value) {
    return 'Date not available';
  }

  const parsedDate = new Date(value);

  if (Number.isNaN(parsedDate.getTime())) {
    return 'Date not available';
  }

  return parsedDate.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function getReadTimeLabel(content = '') {
  const wordCount = content.trim().split(/\s+/).filter(Boolean).length;
  const minutes = Math.max(1, Math.ceil(wordCount / 200));

  return `${minutes} min read`;
}
